export const woonenergieProgressIndicatorTokensColors = {
  progressIndicatorItemDefault: '{{ neutralColors.neutral400 }}',
  progressIndicatorItemDisabled: '{{ neutralColors.neutral200 }}',
  progressIndicatorItemActive: '{{ linkColors.linkBrand }}',
  progressIndicatorItemBorderColor: '{{ linkColors.linkBrand }}',
};
